/**
 * Copyright (c) 2020
 *
 * Contains the representation of a ProductFamily
 *
 * @summary productFamily class definition
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2020-06-08 10:21:56
 * Last modified  : 2021-08-17 15:20:12
 */

import Product from '@/models/customersManager/entity/Product'
import Component from '@/models/customersManager/entity/Component'

class ProductFamily {

    /**
     * @type id Integer
     */
    #id

    /**
     * @type chargifyId Integer
     */
    #chargifyId

    /**
     * @type name String
     */
    #name

    /**
     * @type description null|String
     */
    #description

    /**
     * @type handle null|String
     */
    #handle

    /**
     * @type products Product[]
     */
    #products = []

    /**
     * @type components Component[]
     */
    #components = []

    /**
     * @param rawProductFamily null|Object
     */
    constructor(rawProductFamily = null) {
        const { id, chargifyId, name, description, handle, products, components } = rawProductFamily
        this.id = id
        this.chargifyId = chargifyId
        this.name = name
        this.description = description
        this.handle = handle
        this.products = products
        this.components = components
    }

    /**
     * @returns Integer
     */
    get id () {
        return this.#id
    }

    /**
     * @param id String
     * @returns void
     */
    set id (id) {
        this.#id = parseInt(id)
    }

    /**
     * @returns Integer
     */
    get chargifyId () {
        return this.#chargifyId
    }

    /**
     * @param chargifyId String
     * @returns void
     */
    set chargifyId (chargifyId) {
        this.#chargifyId = parseInt(chargifyId)
    }

    /**
     * @returns String
     */
    get name () {
        return this.#name
    }

    /**
     * @param name String
     * @returns void
     */
    set name (name) {
        this.#name = name
    }

    /**
     * @returns null|String
     */
    get description () {
        return this.#description
    }

    /**
     * @param description String
     * @returns void
     */
    set description (description) {
        this.#description = description
    }

    /**
     * @returns null|String
     */
    get handle () {
        return this.#handle
    }

    /**
     * @param handle String
     * @returns void
     */
    set handle (handle) {
        this.#handle = handle
    }

    /**
     * @returns Product[]
     */
    get products () {
        return this.#products
    }

    /**
     * @param rawProducts Object[]
     * @returns void
     */
    set products (rawProducts) {
        this.#products = []
        if (rawProducts !== null && typeof rawProducts !== 'undefined') {
            rawProducts.forEach((rawProduct) => {
                const product = new Product(rawProduct)
                this.#products = [...this.#products, product]
            });
        }
    }

    /**
     * @returns Component[]
     */
    get components () {
        return this.#products
    }

    /**
     * @param rawComponents Object[]
     * @returns void
     */
    set components (rawComponents) {
        this.#products = []
        if (rawComponents !== null && typeof rawComponents !== 'undefined') {
            rawComponents.forEach((rawComponent) => {
                const component = new Component(rawComponent)
                this.#components = [...this.#components, component]
            });
        }
    }
}

export default ProductFamily
